import React, { useEffect, useState } from "react";
import { Dimmer, Form, Grid, Header, Label, Loader, Card, Image, Checkbox, Search } from 'semantic-ui-react';
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Client from "../Client/api";
import { removeTime, statcastDate } from "../util/utils";
import { MLB_TEAMS_DICTIONARY, INNING_OPTIONS, E_ROD_IMG_SRC, PITCH_GLOSSARY } from "../util/constants";
import VideoDisplay from "./VideoDisplay";

const PitchCard = ({
    pitcherName, 
    game, 
    date, 
    pitchResult, 
    pitchType, 
    pitchVelo, 
    pitcherImage, 
    mode,
    setMode
}) => {

    const handleModeChange = () => {
        if(mode === "GAME") setMode("PITCHER");
        else if(mode === "PITCHER") setMode("GAME");
    };

    return <Card fluid>
        <Image src={pitcherImage ? pitcherImage : "https://www.mlbstatic.com/team-logos/league-on-dark/1.svg"}
        wrapped size="small" centered/>
        <Card.Content>
            <Card.Header>{pitcherName ? pitcherName : "Pitcher List Videos"}</Card.Header>
            <Card.Meta>
                <div>    
                    <div>
                    Game Search
                    </div>
                    <div>
                    <Checkbox slider onChange={handleModeChange}/>
                    </div>
                    <div>
                    Pitcher Search
                    </div>
                </div>
                <div>{game ? game : "Please select a game"}</div>
                <div>{date}</div>
            </Card.Meta>
            {
            pitchType ? 
            <Card.Description>
                <div>Pitch Type: {pitchType}</div>
                <div>Velocity: {pitchVelo} mph</div>
                <div>Pitch Result: {pitchResult}</div>
            </Card.Description>
            : null
            }
        </Card.Content>
    </Card>
};

const HeaderMenu = () => {
    const [mode, setMode] = useState("GAME");
    const [searchLoad, setSearchLoad] = useState(false);
    const [searchValue, setSearchValue] = useState("");
    const [allPitchers, setAllPitchers] = useState([]);
    const [searchResults, setSearchResults] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [allPitcherGames, setAllPitcherGames] = useState([]);
    const [allPitcherGamePks, setAllPitcherGamePks] = useState([]);
    const [pitcherSelected, setPitcherSelected] = useState(false);
    const [pitcherData, setPitcherData] = useState([]);
    const [selectedDate, setSelectedDate] = useState(new Date(Date.now() - 86400000));
    const [selectedDateGames, setSelectedDateGames] = useState([]);
    const [selectedGamePitchers, setSelectedGamePitchers] = useState([]);
    const [selectedPitcher, setSelectedPitcher] = useState();
    const [selectedInningPitches, setSelectedInningPitches] = useState([]);
    const [pitchList, setPitchList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pitcherImage, setPitcherImage] = useState("");
    const [selectedGame, setSelectedGame] = useState();
    const [selectedGameName, setSelectedGameName] = useState("");
    const [gameList, setGameList] = useState([]);
    const [pitcherList, setPitcherList] = useState([]);
    const [selectedPitcherInnings, setSelectedPitcherInnings] = useState([]);
    const [inningsList, setInningsList] = useState([]);
    const [pitchVelo, setPitchVelo] = useState();
    const [pitchType, setPitchType] = useState();
    const [pitchResult, setPitchResult] = useState();

    const [currentUrl, setCurrentUrl] = useState("");
    const [selectedInning, setSelectedInning] = useState();
    const [selectedPitch, setSelectedPitch] = useState();
    const [maxPitches, setMaxPitches] = useState(0);
    const [maxInnings, setMaxInnings] = useState(0);
    const [downInning, setDownInning] = useState(false);
    
    const client = new Client;

    const getPitcherData = (pitcherName) => {
        client.getPitcherGames(pitcherName)
        .then(gameList => {
            const gamePkList = gameList.map(({game_pk}) => game_pk);
            setPitcherData(gameList);
            setAllPitcherGamePks(gamePkList);
        });
    };

    const getAllPitchersList = () => {
        client.getAllPitchers()
        .then(pitcherList => {
            setAllPitchers(pitcherList);
        });
    }

    const getGameList = (date) => {
        client.getGames(date)
        .then(gameList => {
            setSelectedDateGames(gameList?.map(({game, game_pk}, key)=> {
                return {key: key, value: game_pk, text: game};
            }));
            setGameList(gameList);
        });
    }

    const getPitcherList = (gamePk) => {
        client.getGamePitchers(gamePk)
        .then(pitchers => {
            setSelectedGamePitchers(pitchers?.map(({name}, key) => {
                return {key:key, value:name, text:name};
            }));
            setPitcherList(pitchers);
        });
    }

    const resetData = (level) => {
        setPitchType(null);
        setPitchVelo(null);
        setPitchResult(null);
        setCurrentUrl("");
        if(level > 0) setPitchList(null);
        if(level > 1) setInningsList(null);
        if(level > 2) {
            setPitcherList(null);
            setSelectedPitcher(null);
            setPitcherImage(null);
        }
        if(level > 3) setGameList(null);
        if(level > 4) {
            setSearchValue("");
            setSearchQuery("");
            setAllPitcherGamePks([]);
            setAllPitcherGames([]);
            setSearchResults([]);
            setPitcherSelected(false);
            setPitcherData([]);
        }
    }

    const handleSearchChange = (e) => {
        setSearchValue(e.target.value)
        setSearchQuery(e.target.value)
    }

    const handleSearchSelect = (e) => {
        setSearchValue(e.target.innerText);
        setSearchQuery("");
        setPitcherSelected(true);
        setSelectedPitcher(e.target.innerText);
    }

    const fillPitcherGamesInformation = async (gamePks) => {
        const gameNames = [];
        await gamePks.forEach((gamePk) => {
            client.getGameInfo(gamePk)
                .then(({ game, date, game_pk }, key) => {
                    gameNames.push({key: key, value: game_pk, text: `${game} (${date})`})
                });
        });
        setAllPitcherGames(gameNames);
    };

    useEffect(() => {
        resetData(4);
        if(selectedDate) {
            const parsedDate = statcastDate(selectedDate);
            getGameList(parsedDate);
        }
    }, [selectedDate]);

    useEffect(() => {
        if(selectedGame && gameList) {
            resetData(3);
            const name = gameList.filter(({ game_pk }) => game_pk === selectedGame).map(({ game }) => game)[0];
            setSelectedGameName(name);
            getPitcherList(selectedGame);
        }
        else if(selectedGame && pitcherData) {
            resetData(2);
        }
    }, [selectedGame, gameList]);

    useEffect(() => {        
        resetData(2);
        if(selectedPitcher && pitcherList) {
            const pitcher = pitcherList.filter(({name}) => name === selectedPitcher);
            const inningsPitched = pitcher.map(({ innings }) => innings);
            const pitcherImg = pitcher.length > 0 ? pitcher[0].image : null;
            setSelectedPitcherInnings(inningsPitched[0]?.map(({ inning }, key) => {
                return {key:key, value:inning, text:inning};
            }));
            setInningsList(inningsPitched[0]);
            setMaxInnings(inningsPitched[0]?.length);
            setPitcherImage(pitcherImg);
            setSelectedInning(1);
        }
        else if(selectedPitcher && pitcherData) {
            const pitcher = pitcherData.filter(({game_pk}) => {
                return game_pk === selectedGame
            });
            const inningsPitched = pitcher.map(({ innings }) => innings);
            const pitcherImg = pitcher.length > 0 ? pitcher[0].image : null;
            setSelectedPitcherInnings(inningsPitched[0]?.map(({ inning }, key) => {
                return {key:key, value:inning, text:inning};
            }));
            setInningsList(inningsPitched[0]);
            setMaxInnings(inningsPitched[0]?.length);
            setPitcherImage(pitcherImg);
            setSelectedInning(1);
        }
    }, [selectedPitcher, pitcherList, selectedGame, pitcherData]);

    useEffect(() => {
        resetData(1)
        if(selectedInning && inningsList) {
            const pitches = inningsList[selectedInning-1]?.pitches;
            setSelectedInningPitches(pitches?.map(({pitch},key) => {
                return {key:key, value:pitch, text: pitch}
            }))
            setMaxPitches(inningsList[selectedInning-1]?.count);
            setPitchList(pitches);
            if(downInning === true) {
                setSelectedPitch(inningsList[selectedInning-1]?.count);
                setDownInning(false);
            }
            else setSelectedPitch(1);
        }
    }, [selectedInning, inningsList]);

    useEffect(() => {
        resetData(0);
        if(selectedPitch && pitchList?.length > 0) {
            const pitchData = pitchList[selectedPitch-1];
            setPitchType(pitchData?.type);
            setPitchVelo(pitchData?.velocity);
            setPitchResult(pitchData?.result);
            setCurrentUrl(pitchData?.video_url);
        }
    }, [selectedPitch, pitchList]);

    useEffect(() => {
        if(searchQuery.length > 2){
            setPitcherSelected(false);
            setSearchResults(
                allPitchers.filter(pitcher => pitcher.toLowerCase().includes(searchQuery.toLowerCase())).map(pitcher => {return {title: pitcher}})
            );
        }
    }, [searchQuery]);

    useEffect(() => {
        resetData(5);
        if(mode === "PITCHER")
            getAllPitchersList();
        //else setSelectedDate(new Date(Date.now() - 86400000));
    }, [mode]);

    useEffect(() => {
        if(pitcherSelected)
            getPitcherData(selectedPitcher);
    }, [pitcherSelected, selectedPitcher]);

    useEffect(() => {
        if(allPitcherGamePks.length > 0){
            fillPitcherGamesInformation(allPitcherGamePks);
        }
    }, [allPitcherGamePks])

    console.log(selectedPitcherInnings);

    return (
        <Dimmer.Dimmable dimmed={loading}>
            <Dimmer active={loading}>
                <Loader active={loading} inverted>Loading game information</Loader>
            </Dimmer>
                <Form>
                    <Header size="huge" block inverted>
                        <Header.Content>
                            PitcherList Pitch by pitch Video App
                        </Header.Content>
                    </Header>
                    <Grid columns={2} textAlign="center" celled>
                        <Grid.Column width={2}>
                        <Grid.Row>
                            <PitchCard 
                                mode={mode}
                                setMode={setMode}
                                pitcherName={selectedPitcher}
                                game={selectedGameName}
                                pitcherImage={pitcherImage}
                                date={removeTime(selectedDate)}
                                pitchType={pitchType}
                                pitchResult={pitchResult}
                                pitchVelo={pitchVelo}/>
                        </Grid.Row>
                        {
                            mode === "GAME" ?
                            <>
                                <Grid.Row>
                                    <Form.Field id="date_select_game_mode">
                                        <Label content="Date"/>
                                        <ReactDatePicker showIcon selected={selectedDate} onChange={(date) => setSelectedDate(date)}/>
                                    </Form.Field>
                                    <Form.Field id="game_select_game_mode">
                                        <Label content="Game"/>
                                        <Form.Select options={selectedDateGames} onChange={(e, {value}) => {
                                            setSelectedGame(value);
                                        }}/>
                                    </Form.Field>
                                </Grid.Row>
                                <Grid.Row>
                                    <Form.Field id="pitch_select_game_mode">
                                        <Label content="Pitcher"/>
                                        <Form.Select options={selectedGamePitchers} onChange={(e, {value}) => {
                                            setSelectedPitcher(value);
                                        }}/>
                                        <Label content="Inning"/>
                                        <Form.Select options={selectedPitcherInnings} value={selectedInning} onChange={(e, {value}) => {
                                            setSelectedInning(value);
                                        }}/>
                                        <Label content="Pitch"/>
                                        <Form.Select options={selectedInningPitches} value={selectedPitch} onChange={(e, {value}) => {
                                            setSelectedPitch(value);
                                        }}/>
                                    </Form.Field>
                                </Grid.Row>
                            </>
                        :
                        <>
                        <Grid.Row>
                            <Form.Field id="pitcher_select_pitcher_mode">
                                <Label content="Pitcher" />
                                <Search
                                    loading={searchLoad}
                                    placeholder='Search...'
                                    onSearchChange={handleSearchChange}
                                    results={searchResults}
                                    onResultSelect={handleSearchSelect}
                                    value={searchValue}
                                />
                            </Form.Field>
                            <Form.Field id="game_select_pitcher_mode">
                            <Label content="Game"/>
                                        <Form.Select options={allPitcherGames} onChange={(e, {value}) => {
                                            setSelectedGame(value);
                                        }}/>
                            </Form.Field>
                        </Grid.Row>
                        <Grid.Row>
                                    <Form.Field id="pitch_select_pitcher_mode">
                                        <Label content="Inning"/>
                                        <Form.Select options={selectedPitcherInnings || []} value={selectedInning} onChange={(e, {value}) => {
                                            setSelectedInning(value);
                                        }}/>
                                        <Label content="Pitch"/>
                                        <Form.Select options={selectedInningPitches || []} value={selectedPitch} onChange={(e, {value}) => {
                                            setSelectedPitch(value);
                                        }}/>
                                    </Form.Field>
                                </Grid.Row>
                        </>
                        }
                        </Grid.Column>
                        <Grid.Column width={14}>
                            <VideoDisplay 
                                currentUrl={currentUrl}
                                setSelectedPitch={setSelectedPitch}
                                setSelectedInning={setSelectedInning}
                                maxPitches={maxPitches}
                                maxInnings={maxInnings}
                                selectedInning={selectedInning}
                                selectedPitch={selectedPitch}
                                inningsList={inningsList}
                                pitchList={pitchList}
                                setDownInning={setDownInning}
                            />
                        </Grid.Column>
                    </Grid>
                </Form>
        </Dimmer.Dimmable>
    );
}

export default HeaderMenu;